(ns app.front.view.group.admin.standard-texts.model-codes-migrate
  (:require ["@carbon/icons-react/es/arrow--down/32" :default ArrowDown32]
            ["@carbon/icons-react/es/arrow--right/32" :default ArrowRight32]
            [app.domain.model-codes.model :as model-codes-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.checkbox-tree :as ui-ct]
            [app.front.ui.error-boundary :as eb]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.model-codes.common :as model-codes-common]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.media-query :as media-query]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::init
  (fn [{:keys [db]} [_ group-id]]
    {:dispatch [::model-codes-common/init group-id]
     :db       (dissoc db ::data)}))

(rf/reg-sub ::data :-> ::data)

(rf/reg-sub ::books
  :<- [::entities/context]
  :<- [::gas/group-id]
  (fn [[ctx group-id] _]
    (->> (entities/find-entities ctx {:model-code-item/group group-id
                                      :entity/type           :entity.type/model-code-book})
         (sort-by :model-code-item/title >))))

(rf/reg-sub ::target-books
  :<- [::books]
  :<- [::selected-book-id ::source-book]
  (fn [[books source-book-id] _]
    (->> books
         (remove #(-> % :db/id (= source-book-id))))))

(rf/reg-sub ::selected-book-id
  :<- [::data]
  (fn [data [_ book-kind]]
    (-> data ::selected-book-id book-kind)))

(rf/reg-sub ::selected-book
  (fn [[_ book-kind]]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::selected-book-id book-kind])])
  (fn [[ctx book-id]]
    (when book-id
      (entities/find-entity ctx book-id))))

(rf/reg-sub ::source-book-alt-content-items
  :<- [::selected-book ::source-book]
  (fn [book _]
    (when book
      (->> (model-codes-model/item-descendants book)
           (filter :model-code-item/alt-content)
           (sort-by :ordered/order)))))

(rf/reg-sub ::source-book-relevant-item-ids
  :<- [::source-book-alt-content-items]
  (fn [items _]
    (->> items
         (mapcat eu/with-ancestors)
         (map :db/id)
         set)))

(rf/reg-sub ::source-item-children
  :<- [::source-book-relevant-item-ids]
  (fn [entity-ids [_ item]]
    (->> (model-codes-model/item-children item)
         (filter #(contains? entity-ids (:db/id %)))
         (sort-by :ordered/order))))

(rf/reg-sub ::item-children
  (fn [_ [_ item]]
    (->> (model-codes-model/item-children item)
         (sort-by :ordered/order))))

(rf/reg-sub ::selected-source-ids
  :<- [::data]
  :-> ::selected-source-ids)

(defn find-contentful-entities [ctx ids]
  (->> (set ids)
       (entities/find-entities ctx)
       (filter :model-code-item/alt-content)))

(rf/reg-sub ::migrate-enabled?
  :<- [::entities/context]
  :<- [::selected-source-ids]
  :<- [::selected-book-id ::target-book]
  (fn [[ctx ids target-book-id] _]
    (and target-book-id
         (seq (find-contentful-entities ctx ids)))))

(rf/reg-sub ::migration-sources
  :<- [::data]
  :-> ::migrations)

(rf/reg-sub ::migration-source-for
  :<- [::migration-sources]
  (fn [migration-sources [_ target-id]]
    (get migration-sources target-id)))

(rf/reg-sub ::selected-target-ids
  :<- [::migration-sources]
  (fn [sources _]
    (set (keys sources))))

(rf/reg-sub ::partially-selected-target-ids
  :<- [::entities/context]
  :<- [::selected-target-ids]
  (fn [[ctx target-ids] _]
    (->> (entities/find-entities ctx target-ids)
         (mapcat eu/with-ancestors)
         (map :db/id)
         set)))

(rf/reg-sub ::not-selectable
  (constantly false))

(rf/reg-event-fx ::select-book
  (fn [{:keys [db]} [_ group-id book-kind book]]
    {:db       (assoc-in db [::data ::selected-book-id book-kind] (:db/id book))
     :dispatch [::model-codes-common/fetch-group-selections-for-book group-id book]}))

(rf/reg-event-fx ::deselect-book
  (fn [{:keys [db]} [_ book-kind]]
    {:db (p/dissoc-in db [::data ::selected-book-id book-kind])}))

(rf/reg-event-db ::select-source-item
  (fn [db [_ item selected?]]
    (->> (model-codes-model/item-descendants item)
         (concat [item])
         (map :db/id)
         set
         (update-in db [::data ::selected-source-ids] (if selected? set/union set/difference)))))

(rf/reg-event-db ::select-many-source-items
  (fn [db [_ item-ids]]
    (->> (set item-ids)
         (update-in db [::data ::selected-source-ids] set/union))))

(rf/reg-event-fx ::do-automatic-migration
  (fn [{{::keys [data] :as db} :db} [_ tr]]
    (let [ent-ctx         (entities/db->context db)
          source-entities (find-contentful-entities ent-ctx (::selected-source-ids data))
          target-book     (->> data ::selected-book-id ::target-book (entities/find-entity ent-ctx))
          target-entities (->> (model-codes-model/item-descendants target-book)
                               (filter (eu/is-type-fn :entity.type/model-code-content)))
          matches         (->> source-entities
                               (reduce (fn [acc {:model-code-item/keys [ordinal] :as source-item}]
                                         (if-let [target (and ordinal
                                                              (p/find-first target-entities
                                                                            {:model-code-item/ordinal ordinal}))]
                                           (assoc acc (:db/id target) source-item)
                                           acc))
                                       {}))]
      {:db       (assoc-in db [::data ::migrations] matches)
       :dispatch [:notifications/add
                  :toast
                  (if (empty? matches) :warning :success)
                  (if (empty? matches)
                    :model-codes/matching-warning-title
                    :model-codes/matching-success-title)
                  (if (empty? matches)
                    :model-codes/matching-warning
                    (tr [:model-codes/matching-success]
                        [(count matches)]))]})))

(rf/reg-event-db ::set-migration-source
  (fn [db [_ target-id source]]
    (if source
      (assoc-in db [::data ::migrations target-id] source)
      (p/dissoc-in db [::data ::migrations target-id]))))

(rf/reg-event-fx ::save-migration-selections
  (fn [_ [_ migrations]]
    {:dispatch [:comm/command-monitored
                {:command    :model-codes/save-alt-content-for-multiple
                 :method     :post
                 :data       (->> migrations
                                  (p/map-vals :model-code-item/alt-content)
                                  (p/remove-vals str/blank?))
                 :on-success [::save-migration-selections.success]
                 :notify     {:success :model-codes/content-copy-success}}]}))

(rf/reg-event-fx ::save-migration-selections.success
  (fn [{:keys [db]} [_ status changes]]
    {:fx [[:dispatch [::entities/apply-changes status changes]]]
     :db (p/dissoc-in db [::data ::migrations])}))

(defn book-select [{:keys [tr books book-kind on-change disabled?]}]
  [:div.w-full
   [ui-select/select {:id           (str (name book-kind) "-select")
                      :class-name   "full-width-select"
                      :light        true
                      :disabled     (boolean disabled?)
                      :allow-empty? false
                      :label-text   (tr [(keyword "model-codes" (name book-kind))])
                      :select-text  (tr [:model-codes/select-book])
                      :values       books
                      :val->str     :model-code-item/title
                      :value        (<sub [::selected-book book-kind])
                      :on-change    on-change}]])

(defn content-renderer [{:model-code-item/keys [alt-content] :db/keys [id] :keys [content]}]
  (let [tr (<sub [::gas/group-tr])]
    [:div.flex.flex-col.gap-4
     [:div
      [:div.bold.uppercase.text-xs.mb-2 (tr [:model-codes/original-text])]
      [ui-rt/editor-legacy {:id                 (str id "-content")
                            :initial-html-value content}]]
     (when alt-content
       [:div
        [:div.bold.uppercase.text-xs.mb-2 (tr [:model-codes/customized-text])]
        [ui-rt/editor-legacy {:id            (str id "-alt-content")
                              :initial-value alt-content}]])]))

(defn content-and-source-renderer [{:db/keys [id] :as item}]
  (let [source-item (<sub [::migration-source-for id])
        tr          (<sub [::gas/group-tr])
        sources     (<sub [::source-book-alt-content-items])]
    [:<>
     [content-renderer item]
     [:div.w-full.mt-4
      [ui-select/select {:id           (str id "source-select")
                         :class-name   "full-width-select"
                         :allow-empty? true
                         :label-text   (tr [:model-codes/copy-content-from])
                         :select-text  (tr [:model-codes/copy-source-empty])
                         :values       sources
                         :val->str     model-codes-model/model-code-item-label-with-ordinal
                         :value        source-item
                         :on-change    #(>evt [::set-migration-source id %])}]]
     (when-let [source-alt (:model-code-item/alt-content source-item)]
       [:div.w-full.mt-4
        [:div.bold.uppercase.text-xs.mb-2 (tr [:model-codes/new-customized-text])]
        [:div.border-2.border-solid.border-ui-green.rounded.px-2.pt-2.pb-1
         [ui-rt/editor-legacy {:id            (str id "-" (:db/id source-item) "-source-alt-content")
                               :initial-value source-alt}]]])]))

(def book-section-div
  :div.flex.flex-col.w-full.xl:w-auto.xl:flex-1.bg-ui-light-gray.p-5.gap-4.rounded)

(defn source-book-section [{:keys [tr books group-id]}]
  [eb/error-boundary
   (let [selected-book    (<sub [::selected-book ::source-book])
         content-loading? (<sub [:comm/command-processing? :model-codes/group-selections-for-book])
         book-sections    (<sub [::source-item-children selected-book])
         selected-ids     (<sub [::selected-source-ids])
         all-source-ids   (<sub [::source-book-relevant-item-ids])]
     [book-section-div
      [book-select (util/mmap {:book-kind ::source-book
                               :on-change (fn [book]
                                            (>evt [::select-book group-id ::source-book book])
                                            (>evt [::deselect-book ::target-book]))}
                              tr books)]
      (when selected-book
        (cond
          (seq book-sections)
          [:div.w-full
           [:div.mb-1
            [:button.bg-transparent.border-0.p-0.text-ui-blue.hover:underline
             {:on-click #(>evt [::select-many-source-items all-source-ids])}
             (tr [:multi-select/select-all])]]
           [ui-ct/checkbox-tree (util/mmap {:class           "bg-ui-white"
                                            :items           book-sections
                                            :select-evt      [::select-source-item]
                                            :children-sub    [::source-item-children]
                                            :render-content  content-renderer
                                            :item->label     model-codes-model/model-code-item-label-with-ordinal
                                            :item->selected? (fn [item]
                                                               (contains? selected-ids (:db/id item)))
                                            :item->id        :db/id}
                                           tr)]]

          content-loading?
          (cc/loading-spinner {:with-overlay false})

          :else
          [:div (tr [:model-codes/no-book-content-customized])]))])])

(defn target-book-section [{:keys [tr books group-id]}]
  [eb/error-boundary
   (let [selected-book    (<sub [::selected-book ::target-book])
         content-loading? (<sub [:comm/command-processing? :model-codes/group-selections-for-book])
         book-sections    (<sub [::item-children selected-book])
         selected-ids     (<sub [::selected-target-ids])
         partial-sel-ids  (<sub [::partially-selected-target-ids])]
     [book-section-div
      [book-select (util/mmap {:book-kind ::target-book
                               :on-change (fn [book]
                                            (>evt [::select-book group-id ::target-book book]))
                               :disabled? (nil? (<sub [::selected-book ::source-book]))}
                              tr books)]
      (when selected-book
        (cond
          (seq book-sections)
          [:div.w-full {:style {:padding-top "20px"}}
           [ui-ct/checkbox-tree (util/mmap {:class                     "bg-ui-white model-codes-target-book"
                                            :items                     book-sections
                                            :children-sub              [::item-children]
                                            :render-content            content-and-source-renderer
                                            :selectable-sub            [::not-selectable]
                                            :item->label               model-codes-model/model-code-item-label-with-ordinal
                                            :item->selected?           (fn [item]
                                                                         (contains? selected-ids (:db/id item)))
                                            :item->partially-selected? (fn [item]
                                                                         (contains? partial-sel-ids (:db/id item)))}
                                           tr)]]

          content-loading?
          (cc/loading-spinner {:with-overlay false})

          :else
          [:div (tr [:model-codes/no-book-content-customized])]))])])

(defn section []
  (let [tr                (<sub [::gas/group-tr])
        group-id          (<sub [::gas/group-id])
        books             (<sub [::books])
        books-loading?    (<sub [::model-codes-common/books-loading?])
        target-books      (<sub [::target-books])
        migrations        (<sub [::migration-sources])
        no-migrations?    (empty? migrations)
        saving?           (boolean (<sub [:comm/command-processing? :model-codes/save-alt-content-for-multiple]))
        actions-disabled? (or no-migrations? saving?)]
    [acommon/section {}
     (cond
       books-loading?
       (cc/loading-spinner {:with-overlay false})

       (< (count books) 2)
       [:div (tr [:model-codes/not-enough-books])]

       :else
       [:<>
        [ui/help (tr [:model-codes/migrate-codes-info])]
        [:div.w-full.flex.flex-wrap.gap-2
         [source-book-section (util/mmap tr books group-id)]
         [:div.flex.flex-row.w-full.xl:w-auto.xl:flex-col.self-stretch.justify-center
          (cc/icon-button {:render-icon      (if (<sub [::media-query/breakpoint-matches? :xl])
                                               ArrowRight32
                                               ArrowDown32)
                           :class-name       "only-icon-button"
                           :kind             :tertiary
                           :size             :default
                           :icon-description (tr [:model-codes/start-matching])
                           :disabled         (not (<sub [::migrate-enabled?]))
                           :on-click         #(>evt [::do-automatic-migration tr])})]
         [target-book-section (util/mmap {:books target-books}
                                         tr group-id)]]
        [:div.mt-6
         [ui-action-buttons/save-cancel-buttons
          {:on-cancel        #(>evt [::init group-id])
           :cancel-disabled? actions-disabled?
           :save-disabled?   actions-disabled?
           :loading?         saving?
           :on-save          #(>evt [::save-migration-selections migrations])
           :tr               tr}]]])]))
